import * as React from 'react';
import { useAppSelector } from '../../hooks';
import { popupValueSelector } from './popupSlice';
import { Popup as AppPopup } from '../../components/popup';
import './Popup.css';
import { prettifyExpression } from './utils/prettify';
// TODO: Use one tippy and have max height for each pre
export function Popup() {
    const popup = useAppSelector(popupValueSelector);
    const getReferenceClientRect = React.useCallback(() => popup.referenceClientRect, [popup === null || popup === void 0 ? void 0 : popup.referenceClientRect]);
    if (popup === null) {
        return React.createElement(React.Fragment, null);
    }
    const makeTippy = (placement, params) => (React.createElement(AppPopup, { key: placement, className: "dataflow-popup", content: React.createElement(React.Fragment, null, Object.entries(params).map(([k, v]) => (React.createElement("div", { key: k },
            React.createElement("span", { className: "label" },
                k,
                ": "),
            React.createElement("pre", { key: k },
                React.createElement("code", null, v)))))), getReferenceClientRect: getReferenceClientRect, visible: popup !== null, interactive: true, placement: placement, arrow: true, maxWidth: "550px", appendTo: document.body },
        React.createElement("div", null)));
    if (popup.type === 'edge') {
        // If we want to enable popups on edges again, we can add functionality back
        // here
        return React.createElement(React.Fragment, null);
    }
    const { node, value } = popup;
    if (Object.keys(node.params).length === 0) {
        return React.createElement(React.Fragment, null);
    }
    const paramsTippy = makeTippy('top', node.params);
    if (!value || value.type === 'error') {
        return paramsTippy;
    }
    const valueTippy = makeTippy('bottom', value.type === 'function'
        ? { 'Value (function name)': value.functionName }
        : { Value: prettifyExpression(JSON.stringify(value.value), 'Value'.length) });
    return (React.createElement(React.Fragment, null,
        paramsTippy,
        valueTippy));
}
